import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "./ManageToken";

const PrivateRoute = ({ children }) => {
    const isAuthenticated = !!getToken();

    return isAuthenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;